<template>
  <modal
    name="bookingNotesModal"
    height="auto"
    :scrollable="true"
    v-model="show"
  >
    <div class="position-relative modal-outer-container">
      <div class="modal-header border-bottom">
        <div class="ml-3 pl-2">
          {{ title || "Additional Notes" }}
        </div>
        <button class="btn border-0" @click="closeModal">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="notes-container">
          {{ notes || "No additional notes." }}
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "bookingNotesModal",
  props: {
    notes: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Additional Notes",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
  },
};
</script>
<style scoped lang="scss">
.modal-outer-container {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  font-weight: bold;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.notes-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #d2ddec;
  border-radius: 16px;
  padding: 1rem;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
